import React, { useState, useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Button, Container, Row } from 'reactstrap';
import moment from 'moment';

// Services
import { getSessionCookie } from '../../../../services/session';

// Components
import Header from '../../../../components/Headers/Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';

//Contatnts
import { relatorioStyles } from '../../../../constants/relatorioStyles';

function RelatorioHistoricoAtendimentoPontoColeta({ handleReturn, cabecalho, relatorio }) {
    const session = getSessionCookie();

    const refImprimir = useRef();

    // Função acionada assim que o botão de imprimir é clicado
    const handlePrint = useReactToPrint({
        content: () => refImprimir.current,
        copyStyles: true,
        documentTitle: "Relatório Atendimento Analitico",
        pageStyle: relatorioStyles
    });

    return (
        <>
            <Header />
            <Row>
                <Container className="mt--9" fluid>
                    <div className='d-flex justify-content-between align-items-center mb-1'>
                        <Button color="secondary" type="button" onClick={() => handleReturn()}>
                            Voltar
                        </Button>
                        <Button color="danger" type="button" onClick={handlePrint}>
                            <FontAwesomeIcon icon={faPrint} /> Imprimir
                        </Button>
                    </div>
                    <div className="card shadow">
                        <div className='card-body print-padding print' ref={refImprimir}>
                            <div className='row header'>
                                <div className='col-sm-12 col-lg-12 text-center print-image' style={{ display: "none" }}>
                                    <img
                                        src={require("assets/img/brand/logo.png")}
                                        alt="imagem do sistema"
                                        width={150}
                                    />
                                </div>
                                <div className='col-sm-12 col-lg-12'>
                                    <h2>Relatório de Histórico de Atendimento dos Pontos de Coleta</h2>
                                </div>
                                <div className='col-sm-12 col-lg-12'>
                                    <span className='font-weight-bold'>Modalidade de Serviço: </span> <span>{cabecalho?.modalidade}</span>
                                </div>
                                <div className='col-sm-6 col-lg-6'>
                                    <span className='font-weight-bold'>Data Início:</span> <span>{cabecalho?.dataInicio && moment(cabecalho?.dataInicio).format("DD/MM/YYYY")}</span>
                                </div>
                                <div className='col-sm-6 col-lg-6'>
                                    <span className='font-weight-bold'>Data Fim:</span> <span>{cabecalho?.dataFim && moment(cabecalho?.dataFim).format("DD/MM/YYYY")}</span>
                                </div>
                                <div className='col-sm-6 col-lg-6'>
                                    <span className='font-weight-bold'>Divisão Administrativa:</span> <span>{cabecalho?.divisaoAdministrativa}</span>
                                </div>
                                <div className='col-sm-6 col-lg-6'>
                                    <span className='font-weight-bold'>Plano de Trabalho:</span> <span>{cabecalho?.planoTrabalho}</span>
                                </div>
                            </div>
                            <div className='row'>
                                <div className={"mt-3 col-sm-12 col-lg-12 "}>
                                    <div className='table-responsive table-padding'>
                                        <table className='table-bordered tabela-relatorio w-100' >
                                            <thead style={{ background: "#BEBEBE" }}>
                                                <tr>
                                                    <th>MODALIDADE DE SERVIÇO</th>
                                                    <th>DIVISÃO ADMINISTRATIVA</th>
                                                    <th>SETOR/PLANO DE TRABALHO</th>
                                                    <th>RECURSO</th>
                                                    <th>ENDEREÇO</th>
                                                    <th>DATA</th>
                                                    <th>STATUS</th>
                                                    <th>CATEGORIA</th>
                                                    <th>AVULSA</th>
                                                    <th>FREQUÊNCIA</th>
                                                    <th>JUSTIFICATIVA</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {relatorio?.map((value, index) => (
                                                    <React.Fragment key={index}>
                                                        <tr>
                                                            <td className="text-center">{value.modalidade}</td>
                                                            <td className="text-center">{value.divisaoAdministrativa}</td>
                                                            <td className="text-center">{value.planoTrabalho}</td>
                                                            <td className="text-center">{value.veiculo}</td>
                                                            <td className="text-center">{value.endereco}</td>
                                                            <td className="text-center">{value.data}</td>
                                                            <td className="text-center">{value.status}</td>
                                                            <td className="text-center">{value.categoria}</td>
                                                            <td className="text-center">{value.avulsa}</td>
                                                            <td className="text-center">{value.frequencia}</td>
                                                            <td className="text-center">{value.justificativa}</td>
                                                        </tr>
                                                    </React.Fragment>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className='print-footer w-100 mt-2' style={{ display: "none" }}>
                                    <p className='font-weight-bold text-right'>Gerado em {moment().format("DD/MM/YYYY HH:mm")}, Por {session?.nome}.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </Row>
        </>
    );
}

export default RelatorioHistoricoAtendimentoPontoColeta;
